import { useTranslation } from "react-i18next";

import type { HaNPersonRow } from "@lib/logic";

import { HaNResultList } from "../../shared/HaNResultList/HaNResultList";
import { PersonRows } from "./PersonRows";

type PeopleOnFloorProps = {
  people: HaNPersonRow[];
  isConnectionsOnly: boolean;
};

// The selected floor's people
export const PeopleOnFloor = ({ people, isConnectionsOnly }: PeopleOnFloorProps) => {
  const { t } = useTranslation();

  if (people.length === 0) {
    return (
      <HaNResultList.Empty
        text={isConnectionsOnly ? t("hereAndNow:NoConnectionsOnFloor") : t("hereAndNow:NobodyOnFloor")}
      />
    );
  }

  return <PersonRows people={people} />;
};
